export const SECTION_DISCOUNT = {
    ALL: 'ALL',
    FIRST: 'FIRST',
    MAXIMUM: 'MAXIMUM',
}